// extracted by mini-css-extract-plugin
export default {"topicReferencesContainer":"references_topicReferencesContainer__r9Xyx"};